import { BREADCRUMB_SET_NAME } from "@/store/mutation-types";

const state = {
  breadcrumb_names: []
};

const getters = {
  getBreadcrumbNames: state => state.breadcrumb_names,
  getBreadcrumbName: (state, key) => state.breadcrumb_names[key]
};

const mutations = {
  BREADCRUMB_SET_NAME(state, { name, label }) {
    state.breadcrumb_names.push({ name, label });
  }
};

/**
 * Laboratory context actions
 * @type {{LAB_CONTEXT_POPULATE({commit: *})}}
 */
const actions = {
  BREADCRUMB_NAME: ({ commit }, { name, label }) => {
    return new Promise(resolve => {
      commit(BREADCRUMB_SET_NAME, { name, label });
      resolve({ name, label });
    });
  }
};

export default {
  getters,
  mutations,
  actions,
  state
};
